import React from "react";
import { cn } from "@/lib/utils";

export type FriendlyIllustrationKind = "lead-flow" | "stage-reminders" | "partner-network" | "lead-insights";

const ILLUSTRATIONS: Record<FriendlyIllustrationKind, { src: string; width: number; height: number }> = {
  "lead-flow": { src: "/images/illustrations/lead-flow.webp", width: 1536, height: 1024 },
  "stage-reminders": { src: "/images/illustrations/stage-reminders.webp", width: 1305, height: 1205 },
  "partner-network": { src: "/images/illustrations/partner-network.webp", width: 1362, height: 1155 },
  "lead-insights": { src: "/images/illustrations/lead-insights.webp", width: 1254, height: 1254 },
};

interface FriendlyIllustrationProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height"> {
  kind: FriendlyIllustrationKind;
  eager?: boolean;
}

export function FriendlyIllustration({ kind, eager = false, alt = "", className, ...props }: FriendlyIllustrationProps) {
  const illustration = ILLUSTRATIONS[kind];

  return (
    <img
      src={illustration.src}
      width={illustration.width}
      height={illustration.height}
      alt={alt}
      aria-hidden={alt === "" ? true : undefined}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={cn("select-none object-contain", className)}
      {...props}
    />
  );
}
